var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "login-container",
          style: { backgroundImage: "url(" + _vm.loginBg + ")" },
        },
        [
          _c("div", { class: ["header-nav", { sticky: _vm.isSticky }] }, [
            _c("div", { staticClass: "logo" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container-box" },
              _vm._l(_vm.navList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "containerBoxItem",
                    refInFor: true,
                    staticClass: "container-box-item",
                    class: { activeTop: _vm.language === "en" },
                    on: {
                      mouseenter: function ($event) {
                        return _vm.hoverTab(index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "container-box-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.language === "zh" ? item.nameZh : item.nameEn
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    index !== 0
                      ? _c("i", { staticClass: "el-icon-caret-bottom" })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mobile-menu-toggle",
                on: { click: _vm.toggleMobileMenu },
              },
              [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-nav-right" },
              [
                _c(
                  "i",
                  {
                    staticClass: "el-icon-question",
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.handleHelp },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.helpNew")))]
                ),
                _vm._v(" "),
                _vm.language === "en"
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          margin: "0 16px 0 16px",
                          cursor: "pointer",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleSetLanguage("zh")
                          },
                        },
                      },
                      [_vm._v("\n          中文\n        ")]
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          margin: "0 16px 0 16px",
                          cursor: "pointer",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleSetLanguage("en")
                          },
                        },
                      },
                      [_vm._v("English")]
                    ),
                _vm._v(" "),
                _c("router-link", { attrs: { to: "/register" } }, [
                  _vm._v(_vm._s(_vm.$t("home.registerIndex"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "header-nav-right-border" }),
                _vm._v(" "),
                _c("el-avatar", { attrs: { icon: "el-icon-user-solid" } }),
                _vm._v(" "),
                !_vm.userInfo.accountName
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          margin: "0 20px 0 10px",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handleGoLogin },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("home.noLogin")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "class_uaername",
                        staticStyle: {
                          margin: "0 0 0 10px",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handleToUserCenter },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.userInfo.accountName) +
                            "\n        "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _vm.userInfo.accountName
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          margin: "0 10px 0 0",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handleLogOut },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("home.logOut")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "mobileNavMenu",
              staticClass: "mobile-nav-menu",
              class: { active: _vm.showMobileMenu },
            },
            _vm._l(_vm.navList, function (item, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "mobile-nav-item",
                  on: {
                    click: function ($event) {
                      return _vm.handleMobileNavClick(item, index)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.language === "zh" ? item.nameZh : item.nameEn
                      ) +
                      "\n      "
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _c(
              "div",
              {
                ref: "containerListTab",
                staticClass: "container-list-tab",
                on: {
                  mouseleave: function ($event) {
                    return _vm.hoverTabLeave()
                  },
                },
              },
              _vm._l(_vm.navTabList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "container-list-item",
                    class: { "is-active": _vm.currentIndex === index },
                    on: {
                      click: function ($event) {
                        return _vm.handleClickNav(item, index)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-tickets" }),
                    _vm._v("\n          " + _vm._s(item.name) + "\n          "),
                    item.iconLogin && !item.iconAuth
                      ? _c("i", { staticClass: "el-icon-lock icon-position" })
                      : _vm._e(),
                    _vm._v(" "),
                    item.iconLogin && item.iconAuth
                      ? _c("i", {
                          staticClass:
                            "icon iconneishenyuanguanli icon-position",
                        })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-card" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", cursor: "pointer" } },
              _vm._l(_vm.tabList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "border-card",
                    class: { active: _vm.activeTab === index },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = index
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.language === "zh" ? item.name : item.nameEn) +
                        "\n        "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === 0,
                    expression: "activeTab === 0 ",
                  },
                ],
                staticStyle: { padding: "24px" },
              },
              [
                _c(
                  "div",
                  { staticClass: "vesselSearch" },
                  [
                    _c("div", { staticClass: "vesselSearch-border" }, [
                      _vm._v("POL"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vesselSearch-border-border" }),
                    _vm._v(" "),
                    _c("glPort", {
                      on: { change: _vm.changePort },
                      model: {
                        value: _vm.form.pol,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pol", $$v)
                        },
                        expression: "form.pol",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "vesselSearch",
                    staticStyle: { margin: "24px 0" },
                  },
                  [
                    _c("div", { staticClass: "vesselSearch-border" }, [
                      _vm._v("POD"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vesselSearch-border-border" }),
                    _vm._v(" "),
                    _c("glPort", {
                      on: { change: _vm.changePortPod },
                      model: {
                        value: _vm.form.pod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pod", $$v)
                        },
                        expression: "form.pod",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "submitBtn",
                    staticStyle: { width: "100%", background: "#0099e5" },
                    attrs: { type: "primary" },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleSearchPort($event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.search")) + "\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === 1,
                    expression: "activeTab === 1 ",
                  },
                ],
                staticStyle: { padding: "24px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vesselSearch",
                    staticStyle: { margin: "24px 0" },
                  },
                  [
                    _c("div", { staticClass: "vesselSearch-border" }, [
                      _vm._v(_vm._s(_vm.$t("home.vesselName"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vesselSearch-border-border" }),
                    _vm._v(" "),
                    _c("glVesselMain", {
                      on: { change: _vm.changeVessel },
                      model: {
                        value: _vm.form.vesselCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "vesselCode", $$v)
                        },
                        expression: "form.vesselCode",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "submitBtn",
                    staticStyle: {
                      width: "100%",
                      background: "#0099e5",
                      "margin-top": "24px",
                    },
                    attrs: { type: "primary" },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleSearchVessel($event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.search")) + "\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === 2,
                    expression: "activeTab === 2",
                  },
                ],
                staticStyle: { padding: "24px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "select-box",
                    staticStyle: { margin: "24px 0", "padding-left": "0px" },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.form.currentFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "currentFlag", $$v)
                                  },
                                  expression: "form.currentFlag",
                                },
                              },
                              _vm._l(_vm.timeList, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.labelZh
                                        : item.labelEh,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 1 } }, [
                          _c("div", {
                            staticClass: "vesselSearch-border-select",
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100% !important" },
                              model: {
                                value: _vm.form.blNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "blNo", $$v)
                                },
                                expression: "form.blNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "submitBtn",
                    staticStyle: {
                      width: "100%",
                      background: "#0099e5",
                      "margin-top": "24px",
                    },
                    attrs: { type: "primary" },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleSearchBlNo($event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.search")) + "\n        ")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "ourTitle" }, [
        _c("div", { staticClass: "ourTitle-box" }, [
          _vm._v(_vm._s(_vm.$t("home.ourTitle"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-footer-box" }, [
        _vm.bannerMapImage
          ? _c("img", {
              staticClass: "header-footer",
              attrs: {
                src: _vm.bannerMapImage,
                alt: "SITC Banner Map",
                loading: "lazy",
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-footer-box-title" }, [
        _c("div", { staticClass: "header-footer-title" }, [_vm._v("SITC")]),
        _vm._v(" "),
        _vm.language === "en"
          ? _c("div", { staticClass: "header-footer-title-bottom" }, [
              _c("p", [
                _vm._v(
                  " As of Jun 30, 2024,our container shippingservices cover:"
                ),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _c("div", { staticClass: "header-footer-title-bottom" }, [
              _c("p", [
                _vm._v(" 截止2024年6月30日,我们的集装箱航运服务覆盖："),
              ]),
              _vm._v(" "),
              _vm._m(1),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-footer" }, [
        _c("div", { staticClass: "bottom-footer-left" }, [
          _c("div", { staticClass: "bottom-footer-top" }, [
            _c("div", { staticStyle: { "min-width": "195px" } }, [
              _vm._v(_vm._s(_vm.$t("home.serviceSupport"))),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("home.contactUs")))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom-footer-bottom" },
            [
              _c(
                "a",
                {
                  staticClass: "linkClass",
                  staticStyle: { "min-width": "195px" },
                  attrs: {
                    href:
                      _vm.language === "zh"
                        ? "https://api.sitcline.com:9001/workorder/用户注册.pdf"
                        : "https://api.sitcline.com:9001/workorder/User Registration.pdf",
                    target: "_blank",
                  },
                },
                [_vm._v("\n          " + _vm._s(_vm.$t("home.helpCenter")))]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "linkClass", attrs: { to: "/portContacts" } },
                [_vm._v(_vm._s(_vm.$t("home.localContact")) + "\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "bottom-footer-bottom" }, [
            _c(
              "a",
              {
                staticClass: "linkClass",
                staticStyle: { "min-width": "195px" },
                attrs: {
                  href:
                    _vm.language === "zh"
                      ? "https://api.sitcline.com:9001/workorder/用户手册.pdf"
                      : "https://api.sitcline.com:9001/workorder/User Manual.pdf",
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("helpDocuments.helpManual"))
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "linkClass",
                staticStyle: { cursor: "pointer" },
                on: { click: _vm.skipToPortContacts },
              },
              [_vm._v(_vm._s(_vm.$t("home.complaintCenter")) + "\n        ")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom-code" },
          _vm._l(_vm.imgCodeList, function (item, index) {
            return _c("div", { key: index, staticClass: "bottom-code-box" }, [
              _c("img", {
                attrs: { src: item.url, alt: item.text, loading: "lazy" },
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "12px" } }, [
                _vm._v(_vm._s(_vm.language === "zh" ? item.text : item.textEn)),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm._m(2),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "myCode",
          attrs: {
            "z-index": "1999",
            visible: _vm.dialogVisible,
            title: _vm.$t("Announcement.title"),
            top: "210px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "word-break": "keep-all" } }, [
            _c("span", { staticStyle: { "line-height": "20px" } }, [
              _vm._v(_vm._s(_vm.$t("Announcement.text1"))),
            ]),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { "line-height": "20px", "margin-left": "20px" } },
              [_vm._v(_vm._s(_vm.$t("Announcement.text2")))]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "line-height": "20px",
                  "margin-left": "20px",
                  "font-weight": "bold",
                },
              },
              [_vm._v(_vm._s(_vm.$t("Announcement.text3")))]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { "line-height": "20px", "margin-left": "20px" } },
              [_vm._v("    " + _vm._s(_vm.$t("Announcement.text4")))]
            ),
            _c(
              "span",
              { staticStyle: { "line-height": "20px", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.$t("Announcement.text4_1")))]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { "line-height": "20px", "margin-left": "20px" } },
              [_vm._v("    " + _vm._s(_vm.$t("Announcement.text5")))]
            ),
            _c(
              "span",
              { staticStyle: { "line-height": "20px", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.$t("Announcement.text5_1")))]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "line-height": "20px",
                  "margin-left": "20px",
                  "font-weight": "bold",
                },
              },
              [_vm._v(_vm._s(_vm.$t("Announcement.text6_1")))]
            ),
            _c("span", { staticStyle: { "line-height": "20px" } }, [
              _vm._v(_vm._s(_vm.$t("Announcement.text6"))),
            ]),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "line-height": "20px",
                  "margin-left": "20px",
                  "font-weight": "bold",
                },
              },
              [_vm._v(_vm._s(_vm.$t("Announcement.text7_1")))]
            ),
            _c("span", { staticStyle: { "line-height": "20px" } }, [
              _vm._v(_vm._s(_vm.$t("Announcement.text7"))),
            ]),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "line-height": "20px",
                  color: "red",
                  "font-weight": "bold",
                },
              },
              [_vm._v(_vm._s(_vm.$t("Announcement.text8")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("UserLogin", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showUserLogin,
            expression: "showUserLogin",
          },
        ],
        ref: "userLogin",
        on: { forgetPassword: _vm.handleForgetPassword },
      }),
      _vm._v(" "),
      _c("ForgetPassWord", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showForgetPassword,
            expression: "showForgetPassword",
          },
        ],
        ref: "forgetPassWord",
        attrs: { "is-edit-password": _vm.isEditPassword },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v(
          " • 22 ports in Mainland China, with 191 port callings perweek;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(" • 15 ports in Japan, with 104 port callings per week;"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(" • 6 ports in Korea, with 26 port callings per week;"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          " • 30 ports in ASEAN countries, with 120 port callingsper week;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(" • 4 ports in Taiwan, with 16 port callings per week;"),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v(" • Hong Kong with 10 port callings per week;")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(" • 1 port in Bangladesh, with 2 port calling per week;"),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 4 port in India, with 4 port calling per week.")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v(" • 中国大陆22个港口,每周靠港191次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 日本15个港口,每周靠港104次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 韩国6个港口,每周靠港26次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 东盟国家30个港口,每周靠港120次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 中国台湾4个港口,每周靠港16次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 中国香港,每周靠港10次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 孟加拉1个港口,每周靠港2次;")]),
      _vm._v(" "),
      _c("li", [_vm._v(" • 印度4个港口,每周靠港4次.")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-text-box" }, [
      _c("div", [_vm._v("COPYRIGHT@2013 SITC ALL RIGHTS RESERWED")]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-left-text" }),
      _vm._v(" "),
      _c("div", [_vm._v("沪ICP备11020243号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }